import type {
  NationCapacity,
  ResourceStockpile,
} from '../core/economyTypes'

export type FacilityId =
  | 'mine'
  | 'refinery'
  | 'power-plant'
  | 'electronics-plant'
  | 'research-institute'

export interface FacilityDefinition {
  id: FacilityId
  name: string
  shortDescription: string
  buildTurns: number
  cost: ResourceStockpile
  output: ResourceStockpile
  capacity: NationCapacity
  powerDemand: number
}

export const FACILITY_DEFINITIONS: FacilityDefinition[] = [
  {
    id: 'mine',
    name: '矿冶厂',
    shortDescription: '提高金属产量，需要 2 电力负载',
    buildTurns: 2,
    cost: { money: 30, metal: 10, fuel: 0, electronics: 2 },
    output: { money: 0, metal: 5, fuel: 0, electronics: 0 },
    capacity: { power: 0, research: 0 },
    powerDemand: 2,
  },
  {
    id: 'refinery',
    name: '燃料厂',
    shortDescription: '提高燃料产量，需要 2 电力负载',
    buildTurns: 2,
    cost: { money: 32, metal: 8, fuel: 0, electronics: 2 },
    output: { money: 0, metal: 0, fuel: 5, electronics: 0 },
    capacity: { power: 0, research: 0 },
    powerDemand: 2,
  },
  {
    id: 'power-plant',
    name: '发电站',
    shortDescription: '提高国家电力容量 +5',
    buildTurns: 2,
    cost: { money: 36, metal: 12, fuel: 0, electronics: 3 },
    output: { money: 0, metal: 0, fuel: 0, electronics: 0 },
    capacity: { power: 5, research: 0 },
    powerDemand: 0,
  },
  {
    id: 'electronics-plant',
    name: '电子厂',
    shortDescription: '提高电子元件产量，需要 3 电力负载',
    buildTurns: 3,
    cost: { money: 45, metal: 10, fuel: 0, electronics: 6 },
    output: { money: 0, metal: 0, fuel: 0, electronics: 4 },
    capacity: { power: 0, research: 0 },
    powerDemand: 3,
  },
  {
    id: 'research-institute',
    name: '研究院',
    shortDescription: '提高国家科研能力，需要 4 电力负载',
    buildTurns: 3,
    cost: { money: 50, metal: 8, fuel: 0, electronics: 8 },
    output: { money: 0, metal: 0, fuel: 0, electronics: 0 },
    capacity: { power: 0, research: 3 },
    powerDemand: 4,
  },
]

export function getFacilityDefinition(
  facilityId: FacilityId,
): FacilityDefinition {
  const definition = FACILITY_DEFINITIONS.find(
    (facility) => facility.id === facilityId,
  )

  if (!definition) {
    throw new Error(`Unknown facility: ${facilityId}`)
  }

  return definition
}

export function isFacilityId(value: unknown): value is FacilityId {
  return (
    value === 'mine' ||
    value === 'refinery' ||
    value === 'power-plant' ||
    value === 'electronics-plant' ||
    value === 'research-institute'
  )
}
